class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.popup = this.querySelector("div");
    this.closeButton = this.querySelector("#close-newsletter");
    this.init();
  }

  init() {
    // Check local storage to see if the pop-up should be shown
    if (localStorage.getItem("newsletterDismissed")) {
      this.popup.removeAttribute("open");
      return;
    }

    // if ?customer_posted=true#contact_form in the url dismiss the pop up
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get("customer_posted") === "true") {
      this.popup.removeAttribute("open");
      localStorage.setItem("newsletterDismissed", "true");
      return;
    }

    // Automatically open the popup when the page loads
    setTimeout(() => {
      this.popup.setAttribute("open", "true");
    }, 500); // Delay slightly to ensure smooth transition

    // Close button logic
    this.closeButton.addEventListener("click", () => {
      this.popup.removeAttribute("open");
      // local storage after 5 seconds
      setTimeout(() => {
        localStorage.setItem("newsletterDismissed", "true");
      }, 500);
    });
  }
}

// Define the custom element
customElements.define("newsletter-popup", NewsletterPopup);

class SizeChart extends HTMLElement {
  constructor() {
    super();

    // Parse the JSON data from the #chart-data <p> child
    this.sizeChart = JSON.parse(this.querySelector("#chart-data").textContent);

    // Create a shadow DOM for encapsulation
    const shadow = this.attachShadow({ mode: "open" });

    // Apply styles and add the table to the shadow DOM
    const style = document.createElement("style");
    style.textContent = `
      * {
      font-style: normal;
      font-weight: 400;
      text-align: left;
      font-size: 11px;
      }

      table {
      width: 100%;
      outline: 0;
      border-collapse: collapse;
      }

      @media (min-width: 768px) {
      th, td {
      min-width: calc((100vw - 80px) / 16);
      margin-right:12px;
      }
    }

      th {
        padding-bottom: 6px;
      }

      td {
        padding: 6px 0; 
      }

      tr:last-child td {
        padding-bottom: 0;
      }

      .break {
      height: 0.5px;
      background-color: #D1D1D1;
      }
    `;

    // Generate the table and append it to the shadow DOM
    const table = this.generateTable();
    shadow.appendChild(style);
    shadow.appendChild(table);
  }

  // Method to generate the table based on JSON data
  generateTable() {
    const table = document.createElement("table");

    // Create headers from the first item in the data array
    if (this.sizeChart.length > 0) {
      const headers = Object.values(this.sizeChart[0]);
      const thead = document.createElement("thead");
      thead.classList.add("table-header");

      const headerRow = document.createElement("tr");
      headers.forEach((headerText) => {
        const th = document.createElement("th");
        th.textContent = headerText;
        headerRow.appendChild(th);
      });

      thead.appendChild(headerRow);
      table.appendChild(thead);

      // Create table body with data
      const tbody = document.createElement("tbody");
      this.sizeChart.slice(1).forEach((rowData) => {
        const row = document.createElement("tr");

        Object.values(rowData).forEach((cellData) => {
          const cell = document.createElement("td");
          cell.textContent = cellData;
          row.appendChild(cell);
        });

        tbody.appendChild(row);
      });
      table.appendChild(tbody);
    }

    return table;
  }
}

// Define the custom element if it’s not already defined
if (!customElements.get("size-chart")) {
  customElements.define("size-chart", SizeChart);
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.openDrawer = this.openDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.update = this.update.bind(this);
  }

  openDrawer() {
    const header = document.querySelector("header-holder");
    if (header) {
      header.toggle("cart");
    }
  }

  closeDrawer() {
    this.removeAttribute("aria-expanded");
    const header = document.querySelector("header-holder");
    if (header) {
      header.toggle("");
    }
  }

  async update() {
    const res = await fetch("/?section_id=cart-drawer");
    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;

    this.innerHTML = html.querySelector("#cart").innerHTML;
  }

  async addToCart(form) {
    await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });
    // update cart
    await this.update().then(() => {
      this.openDrawer();
    });
  }

  async addVariantToCart(variantId) {
    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);

    await fetch("/cart/add", {
      method: "post",
      body: formData,
    });
    // update cart
    await this.update().then(() => {
      this.openDrawer();
    });
  }
}

if (!customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}

class Newsletter extends HTMLElement {
  constructor() {
    super();
    // elements are input with id email, button with id subscribe
    this.email = this.querySelector("input[id='email']");
    this.button = this.querySelector("button[id='subscribe']");
    this.onClick = this.onClick.bind(this);
    console.log(this.button);

    // if ?customer_posted=true#contact_form is in the url, show a success message
    const urlParams = new URLSearchParams(window.location.search);
    const customerPosted = urlParams.get("customer_posted");
    if (customerPosted === "true") {
      this.changeStatus("Thank you for subscribing");
    }
    this.button.addEventListener("click", this.onClick);
  }
  async onClick(e) {
    console.log(this.email.value);
    if (this.email.value.length < 5) {
      this.changeStatus("Please enter a valid email ");
    }
    // alert('yeas')
  }

  async changeStatus(text) {
    this.querySelector("p").textContent = text;
  }
}

if (!customElements.get("newsletter")) {
  customElements.define("newsletter-widget", Newsletter);
}

class SlideShow extends HTMLElement {
  constructor() {
    super();
    this.initSwiper();
  }

  initSwiper() {
    // Make sure Swiper only initializes when the swiper-container is present
    const swiperContainer = this;
    console.log(swiperContainer);
    if (swiperContainer) {
      const swiper = new Swiper(".swiper", {
        // Swiper options
        slidesPerView: 1, // Number of slides to show
        spaceBetween: 0, // Space between slides
        speed: 400,
        on: {
          init: this.updateProgressBar.bind(this), // Reference to class method
          slideChange: this.updateProgressBar.bind(this), // Reference to class method
        },
      });
      console.log(swiper);
    }
  }
  updateProgressBar() {
    this.querySelector("div[id='progress']").style.width = `${
      ((this.swiper.activeIndex + 1) / this.swiper.slides.length) * 100
    }%`;

    console.log(this.swiper.activeIndex + 1, this.swiper.slides.length);
  }
}

if (!customElements.get("product-slideshow")) {
  customElements.define("product-slideshow", SlideShow);
}

class SearchWidget extends HTMLElement {
  constructor() {
    super();
    this.searchInput = this.querySelector("#search");
    this.searchButton = this.querySelector("#search-button");

    console.log(this.searchInput, this.searchButton);

    // Bind the event handlers
    this.executeSearch = this.executeSearch.bind(this);

    // Listen for Enter key in the input field
    this.searchInput.addEventListener("keydown", this.executeSearch);
    this.searchButton.addEventListener("click", this.executeSearch);
  }

  executeSearch(event) {
    if (event.key === "Enter" || event.type === "click") {
      event.preventDefault();
      const query = this.searchInput.value.trim();

      if (query.length > 0) {
        // Redirect to the Shopify search page with the search query
        window.location.href = `/search?q=${encodeURIComponent(
          query,
        )}&type=product`;
      }
    }
  }
}

// Define the custom element
if (!customElements.get("search-widget")) {
  customElements.define("search-widget", SearchWidget);
}

class Header extends HTMLElement {
  constructor() {
    super();

    this.onDocumentKey = this.onDocumentKey.bind(this);
    this.onOutsideClick = this.onOutsideClick.bind(this);

    // State of all panels
    this.state = {};

    // Store references to DOM elements
    this.panels = {};
    this.toggles = {};
    this.panelHolder = this.querySelector("#nav-panel-holder");
  }

  connectedCallback() {
    // Find all panels with data-panel-name attribute
    const panelElements = this.querySelectorAll("[data-panel-name]");
    panelElements.forEach((el) => {
      const name = el.dataset.panelName;
      this.state[name] = el.getAttribute("aria-expanded") === "true";
      this.panels[name] = el;

      // Find toggle button for this panel
      const toggle = this.querySelector(`[data-toggle-panel="${name}"]`);
      if (toggle) {
        this.toggles[name] = toggle;
        toggle.addEventListener("click", () => this.toggle(name));
      }
    });

    const closeToggles = this.querySelectorAll(`[data-toggle-panel="close"]`);
    // get all close toggles no just that one
    closeToggles.forEach((closeToggle) => {
      closeToggle.addEventListener("click", () => this.toggle(""));
    });

    document.addEventListener("keydown", this.onDocumentKey);
    document.addEventListener("click", this.onOutsideClick);

    this.syncAll();
  }

  disconnectedCallback() {
    Object.entries(this.toggles).forEach(([name, el]) => {
      el.removeEventListener("click", () => this.toggle(name));
    });

    document.removeEventListener("keydown", this.onDocumentKey);
    document.removeEventListener("click", this.onOutsideClick);
  }

  toggle(panelName) {
    const willOpen = !this.state[panelName];

    // Reset all panels
    Object.keys(this.state).forEach((k) => (this.state[k] = false));

    // Reopen toggled panel (if allowed)
    this.state[panelName] = willOpen;

    // const menuLabel = document.getElementById("nav-menu-label");
    // const labelDiv = menuLabel.querySelector("div");
    // const labelSpan = menuLabel.querySelector("span");
    const closeHolder = document.getElementById("nav-close-holder");

    const cartToggle = this.toggles["cart"];
    // if (cartToggle) {
    //   if (panelName === "") {
    //     cartToggle.classList.remove("opacity-0");
    //     cartToggle.classList.remove("pointer-events-none");
    //   } else {
    //     cartToggle.classList.add("opacity-0", "pointer-events-none");
    //   }
    // }

    if (!willOpen || panelName === "") {
      // Ensure product panel stays open if it exists
      if (this.panels["product"]) {
        this.state["product"] = true;
      }

      // labelDiv.removeAttribute("aria-hidden");
      // labelSpan.setAttribute("aria-hidden", true);
      closeHolder.removeAttribute("open");
    } else {
      // labelSpan.textContent = panelName;
      // labelSpan.removeAttribute("aria-hidden");
      // labelDiv.setAttribute("aria-hidden", true);
      closeHolder.setAttribute("open", true);
    }

    this.syncAll();
  }

  syncAll() {
    let scrollHeight = 0;

    Object.keys(this.state).forEach((name) => {
      const panel = this.panels[name];
      const open = this.state[name];

      if (panel) {
        if (open) scrollHeight = panel.scrollHeight;

        panel.setAttribute("aria-expanded", open);
        panel.classList.toggle("is-open", open);
      }
    });

    this.panelHolder.style.maxHeight = `${scrollHeight}px`;
    if (scrollHeight > 0) {
      this.panelHolder.setAttribute("open", true);
    } else {
      this.panelHolder.removeAttribute("open");
    }
  }

  onDocumentKey(e) {
    if (e.key === "Escape") {
      this.toggle("");
      this.syncAll();
    }
  }

  onOutsideClick(e) {
    if (!this.contains(e.target)) {
      this.toggle("");
      this.syncAll();
    }
  }
}

if (!customElements.get("header-holder")) {
  customElements.define("header-holder", Header);
}

class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.addToCartButton = this.querySelector("#add-to-cart");
  }

  connectedCallback() {
    this.addToCartButton.addEventListener("click", (e) => {
      const variantId = this.getAttribute("data-variant-id");
      if (variantId) {
        console.log(variantId);
        this.addVariantToCart(variantId);
      }
    });
  }

  setVariant(variantId) {
    this.setAttribute("data-variant-id", variantId);
    // aria checked
  }

  addVariantToCart(variantId) {
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.addVariantToCart === "function") {
      cartDrawer.addVariantToCart(variantId);
    }
  }
}

if (!customElements.get("product-form")) {
  customElements.define("product-form", ProductForm);
}

class RestockNotify extends HTMLElement {
  constructor() {
    super();
    this.restockButton = this.querySelector("#restock-button");
    this.emailContainer = this.querySelector("#notify");
    this.emailSubmitButton = this.querySelector("#emailSubmitButton");
    this.emailInput = this.querySelector("#emailInput");
    this.init();
  }

  init() {
    // Toggle visibility of the email input form
    this.restockButton.addEventListener("click", () => {
      this.restockButton.classList.toggle("hidden");
      this.emailContainer.classList.toggle("hidden");
      this.emailContainer.classList.toggle("flex");
    });

    // Handle email submission
    this.emailSubmitButton.addEventListener("click", (event) => {
      event.preventDefault();
      if (this.emailInput.value) {
        const variantId = this.emailSubmitButton.getAttribute("variant-id");

        const payload = {
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: this.emailInput.value,
                  },
                },
              },
              channels: ["EMAIL"],
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${variantId}`,
                },
              },
            },
          },
        };
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2024-06-15",
          },
          body: JSON.stringify(payload),
        };

        fetch(
          "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Xug2Bq",
          requestOptions,
        )
          .then((result) => console.log(result))
          .catch((error) => console.log("error", error));

        this.emailInput.value = ""; // Clear the input field

        // Display success message in DOM

        this.emailInput.placeholder = "Submitted!";
      } else {
        alert("Please enter a valid email address.");
      }
    });
  }
}

// Define the custom element
customElements.define("restock-notify", RestockNotify);

class RemoveButton extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.addEventListener("click", this.onClick);
  }

  async onClick(e) {
    e.preventDefault();

    const form = this.closest("form");

    await fetch(e.target.href, {
      method: "post",
      body: new FormData(form),
    });

    // Fetch the updated cart data to check if it's empty
    const response = await fetch("/cart.js");
    const cartData = await response.json();

    // If the cart is empty, close the drawer
    if (cartData.item_count === 0) {
      document.querySelector("cart-drawer").closeDrawer();
    }

    // Update the cart drawer after removing the item
    await document.querySelector("cart-drawer").update();
  }
}

if (!customElements.get("remove-button")) {
  customElements.define("remove-button", RemoveButton);
}
class ProductDescriptionAccordion extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.toggle.bind(this);
    this.handleMediaQuery = this.handleMediaQuery.bind(this);
    this.mq = window.matchMedia("(max-width: 767px)");
  }

  connectedCallback() {
    this.module = this.querySelector(".product-description-module");
    if (!this.module) return;

    const titleEl = this.module.querySelector(
      ".product-description-module-title",
    );
    const descEl = this.module.querySelector(
      ".product-description-module-description",
    );
    if (!titleEl || !descEl) return;

    this.description = descEl;

    // --- create button wrapper + arrow ---
    const parent = titleEl.parentNode;

    const button = document.createElement("button");
    button.type = "button";
    // preserve existing classes and add flex layout
    button.className = `${titleEl.className} flex justify-between items-center w-full text-left`;

    const titleSpan = document.createElement("span");
    titleSpan.textContent = titleEl.textContent.trim();

    const arrowSpan = document.createElement("span");
    arrowSpan.className = "product-description-arrow";
    arrowSpan.textContent = "›"; // swap for SVG if you want

    button.appendChild(titleSpan);
    button.appendChild(arrowSpan);

    // insert button before old <p> and remove the <p>
    parent.insertBefore(button, titleEl);
    parent.removeChild(titleEl);

    this.button = button;

    // initial mode + listener
    this.handleMediaQuery(this.mq);
    this.mq.addEventListener("change", this.handleMediaQuery);
  }

  disconnectedCallback() {
    this.mq.removeEventListener("change", this.handleMediaQuery);
    if (this.button) this.button.removeEventListener("click", this.toggle);
  }

  handleMediaQuery(e) {
    const isMobile = e.matches;
    if (isMobile) {
      this.enableAccordion();
    } else {
      this.disableAccordion();
    }
  }

  enableAccordion() {
    if (this.enabled) return;
    this.enabled = true;

    // closed by default on mobile
    this.description.classList.add("is-closed");
    this.description.style.maxHeight = "0px";

    this.button.addEventListener("click", this.toggle);
  }

  disableAccordion() {
    if (!this.enabled) return;
    this.enabled = false;

    this.button.removeEventListener("click", this.toggle);
    this.description.classList.remove("is-closed");
    this.description.style.maxHeight = "";
    this.module.classList.remove("is-open");
  }

  toggle() {
    const willOpen = this.description.classList.contains("is-closed");

    if (willOpen) {
      // --- OPEN ---
      this.description.classList.remove("is-closed");

      // Wait for next frame so padding + display changes apply first
      requestAnimationFrame(() => {
        const fullHeight = this.description.scrollHeight;
        this.description.style.maxHeight = fullHeight + 10 + "px";
        this.module.classList.add("is-open");
      });
    } else {
      // --- CLOSE ---
      const fullHeight = this.description.scrollHeight;

      // Set current height explicitly (prevents collapse jump)
      this.description.style.maxHeight = fullHeight + "px";

      requestAnimationFrame(() => {
        this.description.classList.add("is-closed");
        this.description.style.maxHeight = "0px";
        this.module.classList.remove("is-open");
      });
    }
  }
}

customElements.define(
  "product-description-accordion",
  ProductDescriptionAccordion,
);
